import React from 'react';
import { DialogContentText } from '@mui/material';

import { LockTarget } from '@paragon/data-connections';
import { closeCurrentPopup, Dialog } from '@paragon/popup-state';

import { batchAffectAllLocks } from '../../store/actions/lockOptionsActions';
import { useAppDispatch } from '../hooks';

export interface ConfirmAffectAllLocksDialogProps {
  readonly componentDesignGuids: string[];
  readonly lockTargets: readonly LockTarget[];
  readonly action: 'lock' | 'unlock';
}

export function ConfirmAffectAllLocksDialog({
  componentDesignGuids,
  lockTargets,
  action,
}: ConfirmAffectAllLocksDialogProps) {
  const dispatch = useAppDispatch();

  return (
    <Dialog
      insistent
      variant="design"
      title={action === 'lock' ? 'Lock Everything?' : 'Unlock Everything?'}
      submitText="Confirm"
      cancelText="Cancel"
      onSubmit={async () => {
        dispatch(closeCurrentPopup());
        await dispatch(batchAffectAllLocks(action)(componentDesignGuids, lockTargets));
      }}
      onCancel={() => {
        dispatch(closeCurrentPopup());
      }}
    >
      <DialogContentText>
        Are you sure you want to {action} everything? Some components have items partially locked, and this cannot be
        undone.
      </DialogContentText>
    </Dialog>
  );
}
